import {api} from '../../api/api';
import {CardIdPayload, reviewActions} from "../review.slice";
import {cardsActions} from "../../cards/cards.slice";
import {call, put} from "redux-saga/effects";
import {navigate} from "@reach/router";
import {PayloadAction} from "@reduxjs/toolkit";
import {ReviewCard} from "../../common";

export function* loadNextSaga(action: PayloadAction<CardIdPayload>) {
    const cardId = action.payload?.cardId;
    try {
        const reviewCard: ReviewCard = yield call(api.getNextReviewCard, cardId);

        // Check if there's an error indicating no cards are available
        if (reviewCard.error === 'No cards found') {
            yield put(reviewActions.setCompletedState());
            navigate('/', {replace: true});
            return;
        }

        if (reviewCard.card) {
            yield put(cardsActions.put([reviewCard.card]));
            yield put(reviewActions.nextCard(reviewCard));
            // Keep the card id in the URL so a refresh resumes the same card.
            navigate(`/review/${reviewCard.card.cardId}`, {replace: true});
        } else {
            // If there's no card in the response, set the state to Completed
            yield put(reviewActions.setCompletedState());
            navigate('/', {replace: true});
        }
    } catch {
        // If there's an error (like no cards found), set the state to Completed
        yield put(reviewActions.setCompletedState());
        navigate('/', {replace: true});
    }
}
